<section class="table-container mat-elevation-z8">
    @if(noActivePeriodsError) {
    <div class="validation-error">
        Det finns inte en aktiv period.
    </div>
    }

    <table mat-table [dataSource]="machineWorkHoursDataSource" class="mat-elevation-z8 machine-hours-table" matSort>
        <ng-container matColumnDef="from-c">
            <th mat-header-cell *matHeaderCellDef>Från och med</th>
            <td mat-cell *matCellDef="let element">
                <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'"
                    [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" floatLabel="always"
                    subscriptSizing="dynamic">
                    <input matInput [matDatepicker]="picker" readonly [(ngModel)]="element.from"
                        [placeholder]="isReadonly ? '-' : 'Välj datum'" [max]="element.to" [readonly]="!this.isPolicyPt"
                        (ngModelChange)="onRowChanged(element)" />
                    <mat-datepicker-toggle matSuffix [for]="picker" [hidden]="!this.isPolicyPt"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    @if(validationErrors[element.id] && validationErrors[element.id].from) {
                    <div class="validation-error">
                        {{ validationErrors[element.id].from }}
                    </div>
                    }
                    @if(validationErrors[element.tempId] && validationErrors[element.tempId].from) {
                    <div class="validation-error">
                        {{ validationErrors[element.tempId].from }}
                    </div>
                    }
                </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>
                <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'"
                    [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" floatLabel="always"
                    subscriptSizing="dynamic">
                    <input matInput [matDatepicker]="picker" readonly [(ngModel)]="newRow.from" placeholder="Välj datum"
                        [max]="newRow.to" [readonly]="!this.isPolicyPt" (ngModelChange)="onNewRowChanged(newRow)" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    @if(validationErrors['newRow'] && validationErrors['newRow'].from) {
                    <div class="validation-error">
                        {{ validationErrors['newRow'].from }}
                    </div>
                    }
                </mat-form-field>
            </td>
        </ng-container>

        <ng-container matColumnDef="to-c">
            <th mat-header-cell *matHeaderCellDef>Till och med</th>
            <td mat-cell *matCellDef="let element">
                <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'"
                    [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" floatLabel="always"
                    subscriptSizing="dynamic">
                    <input matInput [matDatepicker]="picker" readonly [(ngModel)]="element.to"
                        [placeholder]="isReadonly ? '-' : 'Inget slutdatum'" [min]="element.from"
                        (ngModelChange)="onRowChanged(element)" />
                    <div matSuffix class="date-controllers">
                        <mat-datepicker-toggle matSuffix [for]="picker"
                            [hidden]="!this.isPolicyPt"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        @if(this.isPolicyPt) {
                        <button mat-icon-button matSuffix (click)="clearToDate(element)">
                            <mat-icon>close</mat-icon>
                        </button>
                        }
                    </div>
                    @if(validationErrors[element.id] && validationErrors[element.id].to) {
                    <div class="validation-error">
                        {{ validationErrors[element.id].to }}
                    </div>
                    }
                    @if(validationErrors[element.tempId] && validationErrors[element.tempId].to) {
                    <div class="validation-error">
                        {{ validationErrors[element.tempId].to }}
                    </div>
                    }
                </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>
                <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'"
                    [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" floatLabel="always"
                    subscriptSizing="dynamic">
                    <input matInput [matDatepicker]="picker" readonly [(ngModel)]="newRow.to"
                        placeholder="Inget slutdatum" [min]="newRow.from" (ngModelChange)="onNewRowChanged(newRow)" />
                    <div matSuffix class="date-controllers">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <button mat-icon-button matSuffix (click)="clearNewToDate()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    @if(validationErrors['newRow'] && validationErrors['newRow'].to) {
                    <div class="validation-error">
                        {{ validationErrors['newRow'].to }}
                    </div>
                    }

                </mat-form-field>
            </td>
        </ng-container>

        <ng-container matColumnDef="hoursPerDay-c">
            <th mat-header-cell *matHeaderCellDef>Timmar/dygn</th>
            <td mat-cell *matCellDef="let element">
                <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'"
                    [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" floatLabel="always"
                    subscriptSizing="dynamic">
                    <input matInput [value]="element.hoursPerDay" type="number" [(ngModel)]="element.hoursPerDay"
                        (ngModelChange)="onRowChanged(element)" [readonly]="!this.isPolicyPt" min="1" max="24">
                    @if(validationErrors[element.id] && validationErrors[element.id].hoursPerDay) {
                    <div class="validation-error">
                        {{ validationErrors[element.id].hoursPerDay }}
                    </div>
                    }
                    @if(validationErrors[element.tempId] && validationErrors[element.tempId].hoursPerDay) {
                    <div class="validation-error">
                        {{ validationErrors[element.tempId].hoursPerDay }}
                    </div>
                    }
                </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>
                <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'"
                    [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}" floatLabel="always"
                    subscriptSizing="dynamic">
                    <input matInput [(ngModel)]="newRow.hoursPerDay" (ngModelChange)="onNewRowChanged(newRow)"
                        type="number" [readonly]="!this.isPolicyPt" min="1" max="24">
                    @if(validationErrors['newRow'] && validationErrors['newRow'].hoursPerDay) {
                    <div class="validation-error">
                        {{ validationErrors['newRow'].hoursPerDay }}
                    </div>
                    }
                </mat-form-field>
            </td>
        </ng-container>

        <ng-container matColumnDef="action-c">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
                <div class="button-container">
                    <button class="action-button" mat-raised-button (click)="removeRow(element, i)"
                        matTooltip="Ta bort">
                        Ta bort
                    </button>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef>
                <div class="button-container">
                    <button class="action-button" mat-raised-button (click)="addNewRow()"
                        [disabled]="!newRowValidates()">
                        Lägg till
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row [hidden]="row?.clientStatus == clientStatus.Deleted"
            *matRowDef="let row; columns: displayedColumns;"></tr>
        @if(this.isPolicyPt) {
        <tr mat-footer-row *matFooterRowDef="displayedColumns" class="table-footer-row"></tr>
        }
    </table>

</section>